import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { pageModelThunk } from '../../page-model';

export const { actions, reducer } = createSlice({
  name: 'activeRegionId',
  initialState: '',
  reducers: {
    setActiveRegionId: (state, action: PayloadAction<string>) => action.payload,
  },
  extraReducers: builder => {
    builder.addCase(pageModelThunk.fulfilled, (state, { payload }) => payload?.properties.regionId);
  },
});
